function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { FormControl, FormHelperText } from "@mui/material";
import { useCamelCase } from "@vestwell-frontend/hooks";
import cn from "clsx";
import { useField } from "formik";
import { useCallback, useContext, useId } from "react";
import { TextBox } from "../TextBox";
import { IsRequiredFieldContext } from "./Form";
import { FormFieldLabel } from "./FormFieldLabel";
export var FormField = function(_param) {
    var ariaDescribedBy = _param['aria-describedby'], ariaLabelledBy = _param['aria-labelledby'], className = _param.className, details = _param.details, disabled = _param.disabled, endAdornment = _param.endAdornment, helpModal = _param.helpModal, hideLabel = _param.hideLabel, hideLocked = _param.hideLocked, hideError = _param.hideError, help = _param.help, label = _param.label, fieldClassName = _param.fieldClassName, readOnly = _param.readOnly, props = _object_without_properties(_param, [
        'aria-describedby',
        'aria-labelledby',
        "className",
        "details",
        "disabled",
        "endAdornment",
        "helpModal",
        "hideLabel",
        "hideLocked",
        "hideError",
        "help",
        "label",
        "fieldClassName",
        "readOnly"
    ]);
    var _useContext_props_name;
    var isRequired = (_useContext_props_name = useContext(IsRequiredFieldContext)[props.name]) !== null && _useContext_props_name !== void 0 ? _useContext_props_name : false;
    var testId = useCamelCase(props.name);
    var _useField = _sliced_to_array(useField({
        name: props.name,
        validate: props.validate
    }), 3), field = _useField[0], meta = _useField[1], helpers = _useField[2];
    var detailsId = useId();
    var disabledId = useId();
    var helpModalId = useId();
    var errorId = useId();
    var infoId = useId();
    var labelId = useId();
    var errorMessage = meta.touched ? meta.error : undefined;
    var describedBy = "".concat(ariaDescribedBy ? "".concat(ariaDescribedBy, " ") : '').concat(disabled ? "".concat(disabledId, " ") : '').concat(help ? "".concat(infoId, " ") : '').concat(helpModal ? "".concat(helpModalId, " ") : '').concat(details ? "".concat(detailsId, " ") : '').concat(errorMessage ? "".concat(errorId, " ") : '').trimEnd() || undefined;
    var onChange = useCallback(function(value) {
        helpers.setValue(value);
        if (props.onChange) {
            props.onChange(value);
        }
    }, [
        helpers.setValue,
        props.onChange
    ]);
    var _field_value;
    return /*#__PURE__*/ _jsxs(FormControl, {
        className: cn('flex', className),
        "data-component": "textField",
        "data-testid": testId,
        error: !!meta.error && !!meta.touched,
        required: !!isRequired,
        children: [
            /*#__PURE__*/ _jsx(FormFieldLabel, {
                "data-component": "textFieldLabel",
                details: details,
                detailsId: detailsId,
                disabled: disabled,
                disabledId: disabledId,
                helpModal: helpModal,
                helpModalId: helpModalId,
                hideLabel: hideLabel,
                hideLocked: hideLocked,
                info: help,
                infoId: infoId,
                label: label,
                labelId: labelId,
                name: props.name,
                required: !!isRequired
            }),
            /*#__PURE__*/ _jsx(TextBox, _object_spread_props(_object_spread({}, props), {
                "aria-describedby": describedBy,
                "aria-invalid": !!meta.error && !!meta.touched,
                "aria-labelledby": "".concat(ariaLabelledBy ? "".concat(ariaLabelledBy, " ") : '').concat(labelId),
                className: fieldClassName,
                disabled: disabled,
                endAdornment: endAdornment,
                id: props.id || props.name,
                label: label,
                onBlur: props.onBlur || field.onBlur,
                onChange: onChange,
                readOnly: readOnly,
                required: isRequired,
                value: (_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : ''
            })),
            /*#__PURE__*/ _jsx(FormHelperText, {
                "aria-atomic": "true",
                className: "mx-0",
                "data-component": "textFieldError",
                "data-testid": testId,
                id: errorId,
                role: "alert",
                children: !hideError && errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(InfoOutlined, {
                            className: "mr-1",
                            color: "error",
                            fontSize: "small"
                        }),
                        !!label && /*#__PURE__*/ _jsxs("span", {
                            className: "sr-only",
                            children: [
                                "Error for ",
                                label,
                                ":"
                            ]
                        }),
                        errorMessage
                    ]
                }) : ' '
            })
        ]
    });
};
FormField.displayName = 'FormField';

//# sourceMappingURL=FormField.js.map